
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Groupe 1521","xmlns":"http://www.w3.org/2000/svg","width":"21.666","height":"21.666"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"data-name":"Rectangle 1275","fill":"none","d":"M0 0h21.666v21.666H0z"}})])]),_c('g',{attrs:{"data-name":"Groupe 1520","clip-path":"url(#a)"}},[_c('path',{attrs:{"data-name":"Tracé 6789","d":"M13.386 15.677a2.547 2.547 0 01-1.174.411c-.528.061-.587-.587-.587-.939.135-.948.329-1.936.464-2.608.206-1.029.351-1.741.475-2.441a5.8 5.8 0 00.117-1v-.019a.664.664 0 00-.7-.627 25.673 25.673 0 00-3.7.059c-.528.122-.528.646-.117.822.646.237 1.35-.116 1.174 1-.294 1.7-.646 3.4-.881 5.167-.357 2.642 4.815 2.466 5.343.528.057-.294-.178-.47-.414-.353","fill":"#eff1f4"}}),_c('path',{attrs:{"data-name":"Tracé 6790","d":"M13.035 5.93a1.766 1.766 0 00-1.765-1.761h-.081a1.762 1.762 0 00.084 3.523 1.8 1.8 0 001.762-1.762","fill":"#eff1f4"}}),_c('path',{attrs:{"data-name":"Tracé 6791","d":"M10.8 0A10.863 10.863 0 000 10.8v.065A10.833 10.833 0 1010.8 0M8.457 15.5c.235-1.762.587-3.464.881-5.167.176-1.116-.528-.763-1.174-1-.411-.176-.411-.7.117-.822a25.532 25.532 0 013.7-.059.664.664 0 01.7.626V9.1a5.709 5.709 0 01-.117 1c-.124.7-.269 1.412-.475 2.441-.135.672-.329 1.66-.464 2.608 0 .352.059 1 .587.939a2.566 2.566 0 001.174-.411c.236-.117.471.059.414.353-.528 1.938-5.7 2.114-5.343-.528M9.47 5.973a1.762 1.762 0 011.72-1.8h.08a1.766 1.766 0 011.765 1.761 1.8 1.8 0 01-1.762 1.762 1.762 1.762 0 01-1.8-1.72","fill":"#c22292"}})])])
          )
        }
      }
    